import { useId } from 'react'

export const DotsAnimation = ({ className }: { className?: string }) => {
  const svgId = useId()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="1200"
      height="600"
      viewBox="0 0 1200 600"
      className={className}
    >
      <defs>
        <animateMotion
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_4_G`}
          fill="freeze"
          keyTimes="0;0.1333333;0.3333333;0.4666667;0.6666667;0.8;1"
          path="M600 249 C600,249 600,249 600,249 C600,249 540.1,350.45 540.1,350.45 C540.1,350.45 540.1,350.45 540.1,350.45 C540.1,350.45 660.1,350.45 660.1,350.45 C660.1,350.45 660.1,350.45 660.1,350.45 C660.1,350.45 600,249 600,249 "
          keyPoints="0;0;0.33;0.33;0.67;0.67;1"
          keySplines="0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_4_G`}
          fill="freeze"
          attributeName="transform"
          from="0 51"
          to="0 51"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="0 51;0 51"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_3_G`}
          fill="freeze"
          keyTimes="0;0.1333333;0.3333333;0.4666667;0.6666667;0.8;1"
          path="M540.1 350.45 C540.1,350.45 540.1,350.45 540.1,350.45 C540.1,350.45 660.1,350.45 660.1,350.45 C660.1,350.45 660.1,350.45 660.1,350.45 C660.1,350.45 600,249 600,249 C600,249 600,249 600,249 C600,249 540.1,350.45 540.1,350.45 "
          keyPoints="0;0;0.34;0.34;0.67;0.67;1"
          keySplines="0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_3_G`}
          fill="freeze"
          attributeName="transform"
          from="0 51"
          to="0 51"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="0 51;0 51"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_2_G`}
          fill="freeze"
          keyTimes="0;0.1333333;0.3333333;0.4666667;0.6666667;0.8;1"
          path="M540.1 350.45 C540.1,350.45 540.1,350.45 540.1,350.45 C540.1,350.45 660.1,350.45 660.1,350.45 C660.1,350.45 660.1,350.45 660.1,350.45 C660.1,350.45 600,249 600,249 C600,249 600,249 600,249 C600,249 540.1,350.45 540.1,350.45 "
          keyPoints="0;0;0.34;0.34;0.67;0.67;1"
          keySplines="0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_2_G`}
          fill="freeze"
          attributeName="transform"
          from="0 51"
          to="0 51"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="0 51;0 51"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_1_G`}
          fill="freeze"
          keyTimes="0;0.1333333;0.3333333;0.4666667;0.6666667;0.8;1"
          path="M660.1 350.45 C660.1,350.45 660.1,350.45 660.1,350.45 C660.1,350.45 600,249 600,249 C600,249 600,249 600,249 C600,249 540.1,350.45 540.1,350.45 C540.1,350.45 540.1,350.45 540.1,350.45 C540.1,350.45 660.1,350.45 660.1,350.45 "
          keyPoints="0;0;0.33;0.33;0.66;0.66;1"
          keySplines="0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_1_G`}
          fill="freeze"
          attributeName="transform"
          from="0 51"
          to="0 51"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="0 51;0 51"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_0_G`}
          fill="freeze"
          keyTimes="0;0.1333333;0.3333333;0.4666667;0.6666667;0.8;1"
          path="M660.1 350.45 C660.1,350.45 660.1,350.45 660.1,350.45 C660.1,350.45 600,249 600,249 C600,249 600,249 600,249 C600,249 540.1,350.45 540.1,350.45 C540.1,350.45 540.1,350.45 540.1,350.45 C540.1,350.45 660.1,350.45 660.1,350.45 "
          keyPoints="0;0;0.33;0.33;0.66;0.66;1"
          keySplines="0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="3s"
          begin="0s"
          xlinkHref={`#${svgId}-_R_G_L_0_G`}
          fill="freeze"
          attributeName="transform"
          from="0 51"
          to="0 51"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="0 51;0 51"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate attributeType="XML" attributeName="opacity" dur="3s" from="0" to="1" xlinkHref={`#${svgId}-time_group`} />
      </defs>
      <g id={`${svgId}-_R_G`}>
        <g id={`${svgId}-_R_G_L_4_G`}>
          <path
            id={`${svgId}-_R_G_L_4_G_D_0_P_0`}
            fill="currentColor"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-0.1 -74.98 C12.89,-74.98 23.44,-64.43 23.44,-51.45 C23.44,-38.46 12.89,-27.91 -0.1,-27.91 C-13.09,-27.91 -23.63,-38.46 -23.63,-51.45 C-23.63,-64.43 -13.09,-74.98 -0.1,-74.98z "
          />
        </g>
        <g id={`${svgId}-_R_G_L_3_G`}>
          <path
            id={`${svgId}-_R_G_L_3_G_D_0_P_0`}
            fill="currentColor"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-0.1 -74.98 C12.89,-74.98 23.44,-64.43 23.44,-51.45 C23.44,-38.46 12.89,-27.91 -0.1,-27.91 C-13.09,-27.91 -23.63,-38.46 -23.63,-51.45 C-23.63,-64.43 -13.09,-74.98 -0.1,-74.98z "
          />
        </g>
        <g id={`${svgId}-_R_G_L_2_G`} opacity="0.33">
          <path
            id={`${svgId}-_R_G_L_2_G_D_0_P_0`}
            fill="#000000"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-0.1 -74.98 C12.89,-74.98 23.44,-64.43 23.44,-51.45 C23.44,-38.46 12.89,-27.91 -0.1,-27.91 C-13.09,-27.91 -23.63,-38.46 -23.63,-51.45 C-23.63,-64.43 -13.09,-74.98 -0.1,-74.98z "
          />
        </g>
        <g id={`${svgId}-_R_G_L_1_G`}>
          <path
            id={`${svgId}-_R_G_L_1_G_D_0_P_0`}
            fill="currentColor"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-0.1 -74.98 C12.89,-74.98 23.44,-64.43 23.44,-51.45 C23.44,-38.46 12.89,-27.91 -0.1,-27.91 C-13.09,-27.91 -23.63,-38.46 -23.63,-51.45 C-23.63,-64.43 -13.09,-74.98 -0.1,-74.98z "
          />
        </g>
        <g id={`${svgId}-_R_G_L_0_G`} opacity="0.5">
          <path
            id={`${svgId}-_R_G_L_0_G_D_0_P_0`}
            fill="#ffffff"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-0.1 -74.98 C12.89,-74.98 23.44,-64.43 23.44,-51.45 C23.44,-38.46 12.89,-27.91 -0.1,-27.91 C-13.09,-27.91 -23.63,-38.46 -23.63,-51.45 C-23.63,-64.43 -13.09,-74.98 -0.1,-74.98z "
          />
        </g>
      </g>
      <g id={`${svgId}-time_group`} />
    </svg>
  )
}
